import { useBoothConfig } from "../store/booth";
import { useI18n } from "../i18n/useI18n";

export const DEFAULT_WORDMARK = "fiket";

/**
 * 헤더·인화 프레임·어트랙트가 공유하는 브랜딩 값.
 * 텍스트(제목·부제·캡션)는 useI18n 이 이미 브랜딩 → 문구 오버라이드 순으로 합쳐 준다 (schema `resolveCopy`, BOOTH-33).
 * 여기서는 워드마크와 이미지 모드만 다룬다.
 */
export function useBranding() {
  const branding = useBoothConfig((s) => s.config?.branding ?? null);
  const { t } = useI18n();

  const wordmark = branding?.attractWordmark?.trim() || DEFAULT_WORDMARK;
  const title = t.attract.headline;
  const subtitle = t.attract.tagline;
  const caption = t.common.brandCaption;
  const imageUrl =
    branding?.mode === "image" && typeof branding.attractImageUrl === "string" && branding.attractImageUrl
      ? branding.attractImageUrl
      : null;

  return { wordmark, title, subtitle, caption, imageUrl };
}
